import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/**
 * Hook that detects password recovery tokens in the URL and ensures
 * the user is redirected to the reset-password page before any other
 * auth processing can hijack the flow.
 * 
 * This must run at the App level BEFORE any other auth hooks.
 */
export const usePasswordRecoveryDetection = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Check URL hash for recovery tokens
    const hashParams = new URLSearchParams(window.location.hash.substring(1));
    const type = hashParams.get('type');
    const accessToken = hashParams.get('access_token');
    
    // Also check query params (some email clients may transform the URL)
    const queryParams = new URLSearchParams(window.location.search);
    const queryType = queryParams.get('type');
    
    const isRecoveryFlow = type === 'recovery' || queryType === 'recovery';
    const hasTokens = !!accessToken;
    
    // If we detect a recovery flow AND we're not already on reset-password page
    if (isRecoveryFlow && hasTokens && location.pathname !== '/reset-password') {
      console.log('usePasswordRecoveryDetection: Recovery tokens detected, setting flag and redirecting');
      
      // Set the flag IMMEDIATELY to prevent any auth redirects
      sessionStorage.setItem('password_reset_in_progress', 'true');
      
      // Redirect to reset-password with the hash intact
      navigate('/reset-password' + window.location.hash, { replace: true });
    }
    
    // Also set the flag if we're already on reset-password with tokens
    if (location.pathname === '/reset-password' && hasTokens) {
      console.log('usePasswordRecoveryDetection: On reset-password page with tokens, ensuring flag is set');
      sessionStorage.setItem('password_reset_in_progress', 'true');
    }
  }, [navigate, location.pathname]);
};
